import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

const HoursCalculatorPage = () => {
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [breakMinutes, setBreakMinutes] = useState('');
  const [result, setResult] = useState(null);

  const calculate = () => {
    if (startTime && endTime) {
      const [startH, startM] = startTime.split(':').map(Number);
      const [endH, endM] = endTime.split(':').map(Number);
      const breakMins = parseInt(breakMinutes) || 0;

      let totalMinutes = (endH * 60 + endM) - (startH * 60 + startM) - breakMins;
      if (totalMinutes < 0) totalMinutes += 24 * 60; // Handles overnight shifts

      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      const decimal = (totalMinutes / 60).toFixed(2);

      setResult({ hours, minutes, decimal, totalMinutes });
    }
  };

  return (
    <div className="min-h-screen bg-[#0d0d0d] flex flex-col">
      <Header />
      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-4 py-8">
          <nav className="text-sm text-gray-500 mb-4">
            <Link to="/home" className="text-cyan-400 hover:text-cyan-300">Home</Link>
            <span className="mx-2">›</span>
            <span className="text-gray-400">Hours Calculator</span>
          </nav>
          <h1 className="text-3xl font-bold text-white mb-2">Hours Calculator</h1>
          <p className="text-gray-400 mb-8">Calculate work hours between start and end times.</p>

          <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-6">
            <div className="grid md:grid-cols-3 gap-5">
              <div>
                <label className="block text-gray-300 mb-2 font-medium">Start Time</label>
                <Input type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} className="w-full bg-[#0d0d0d] border-[#2a2a2a] text-white [color-scheme:dark]" />
              </div>
              <div>
                <label className="block text-gray-300 mb-2 font-medium">End Time</label>
                <Input type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} className="w-full bg-[#0d0d0d] border-[#2a2a2a] text-white [color-scheme:dark]" />
              </div>
              <div>
                <label className="block text-gray-300 mb-2 font-medium">Break (minutes)</label>
                <Input type="number" value={breakMinutes} onChange={(e) => setBreakMinutes(e.target.value)} className="w-full bg-[#0d0d0d] border-[#2a2a2a] text-white" placeholder="30" />
              </div>
            </div>
            <Button onClick={calculate} className="mt-5 bg-cyan-600 hover:bg-cyan-500 text-white">Calculate</Button>
            {result && (
              <div className="mt-6 p-5 bg-[#0d0d0d] border border-[#2a2a2a] rounded-xl">
                <div className="grid grid-cols-2 gap-4">
                  <div className="p-4 bg-cyan-500/10 border border-cyan-500/30 rounded-lg text-center">
                    <span className="text-gray-400 text-sm">Hours Worked</span>
                    <p className="text-2xl font-bold text-cyan-400">{result.hours}h {result.minutes}m</p>
                  </div>
                  <div className="p-4 bg-[#1a1a1a] rounded-lg text-center">
                    <span className="text-gray-500 text-sm">Decimal Hours</span>
                    <p className="text-2xl font-bold text-white">{result.decimal}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default HoursCalculatorPage;
